/* eslint-disable @typescript-eslint/no-unused-vars */
import Box from "@mui/material/Box";
import React from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { IUser } from "../../../types/user";
import UserDetailForm from "./UserDetailForm";
import { ICompany } from "../../../types/company";
import { useTranslation } from "react-i18next";
export default function UserFormDialog({
  user,
  open,
  onClose,
  onUpdated,
  onNewCreated,
  clientCompany,
}: {
  user?: IUser;
  open: boolean;
  onClose: () => void;
  onUpdated?: (updateInfo: IUser) => void;
  onNewCreated?: (created: IUser) => void;
  clientCompany?: ICompany;
}): React.ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <Dialog open={open} maxWidth="sm">
        <Box sx={{ width: "1000px", maxWidth: "100%" }}>
          <Box
            p={2}
            pb={0}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography variant="h6">
              {user ? t("User Details") : t("New User")}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box p={2}>
            <UserDetailForm
              user={user}
              onNewCreated={onNewCreated}
              onUpdated={onUpdated}
              clientCompany={clientCompany}
            />
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
